import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Observable} from 'rxjs';
import {isPlatformServer} from '@angular/common';
import {AuthService} from './auth.service';
import {HistoryHelperService} from './history-helper.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard  {

    constructor(@Inject(PLATFORM_ID) private platformId: Object,
                private authService: AuthService, private historyHelperService: HistoryHelperService) {
    }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (isPlatformServer(this.platformId)) {
            return false;
        }
        return this.checkLogin(state.url);
    }

    private checkLogin(url: string): boolean {
        if (url.length > 2 && url.indexOf('request-details') > -1) {
            this.historyHelperService.storeHistory(HistoryHelperService.URL_KEY, url);
        }
        if (this.authService.isLoggedIn()) {
            return true;
        } else {
            this.authService.redirectToHome('Not Authorized');
            return false;
        }

    }
}
